// console.log("collection.js");

// --- Initialize Swipe on Products ---
let setProduct = function (singleProduct) {
  if (singleProduct.dataset.status == "dynamic") {
    return;
  } else {
    let addSwiper = singleProduct.querySelector(".swiper-container");

    var swiper = new Swiper(addSwiper, {
      loop: true,
      navigation: {
        nextEl: singleProduct.querySelector(".swiper-button-next"),
        prevEl: singleProduct.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: singleProduct.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });

    // Save swiper instance to product element
    singleProduct.swiperInstance = swiper;

    singleProduct.dataset.status = "dynamic";
  }
};

window.addEventListener("load", function () {
  let allProducts = document.querySelectorAll(".loop .product");

  allProducts.forEach(function (item, i) {
    setProduct(item);
  });

  let nextBtn = document.querySelector("#next-btn");

  if (nextBtn) {
    var elem = document.querySelector(".loop");
    var infScroll = new InfiniteScroll(elem, {
      path: "#next-btn",
      append: ".product",
      history: false,
    });

    infScroll.on("append", function () {
      let allProducts = document.querySelectorAll(".loop .product");

      allProducts.forEach(function (item, i) {
        setProduct(item);
      });

      plpAddToCart();
    });
  }
});

// --- Sort Form ---
let sortForm = document.querySelector("#sort-form");

if (sortForm) {
  let sortBtn = sortForm.querySelector(".sort-btn");

  sortBtn.addEventListener("click", function (event) {
    event.preventDefault();
    let sortSelect = sortForm.querySelector(".sort-select");
    sortSelect.classList.toggle("active");
  });
}

// --- Product Add To Cart + Variant Price + Variant Image Switch ---
let plpAddToCart = function () {
  let products = document.querySelectorAll(".product");
  
  products.forEach((product) => {
    let addToCartBtn = product.querySelector(".plp-atc-btn");
    let selectOptions = product.querySelector("select");
    let price = product.querySelector(".details .price");

    if (selectOptions) {
      selectOptions.addEventListener("change", function () {
        let current = selectOptions.options[selectOptions.selectedIndex].value;
        let selectedOption = selectOptions.options[selectOptions.selectedIndex];

        // Update Price
        if (selectedOption.dataset.price) {
          price.innerText = selectedOption.dataset.price;
        }

        product.classList.add("atc-on");
        addToCartBtn.dataset.atcId = current;

        // --- Variant Image Switch ---
        let swiperSlides = product.querySelectorAll('.swiper-slide');
        let selectedVariantId = current;
        let found = false;

        swiperSlides.forEach((slide, index) => {
          const variantIds = slide.dataset.variantIds ? slide.dataset.variantIds.split(',') : [];

          if (variantIds.includes(selectedVariantId)) {
            found = true;
            if (product.swiperInstance) {
              product.swiperInstance.slideTo(index);
            }
          }
        });

        if (!found && product.swiperInstance) {
          product.swiperInstance.slideTo(0);
        }
      });
    }

    // Add to Cart Click
    addToCartBtn.addEventListener("click", function (event) {
      event.preventDefault();
      if (addToCartBtn.dataset.atcId) {
        addToCart(addToCartBtn.dataset.atcId);
      } else {
        console.log("Select a size");
      }
    });
  });
};

let addToCart = function (id) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: id,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  })
  .then(response => response.json())
  .then(cartData => {
    console.log(cartData);
    updateCartCount(cartData.item_count);
    updateSubtotal(cartData.total_price);
    updateSideCart(cartData);

    // Open Side Cart
    document.getElementById("side-cart").classList.add("active");
  })
  .catch(error => console.error('Error adding item to cart:', error));
};

plpAddToCart();

// --- Toggle View ---
let toggleViewBtn = document.querySelector(".toggle-view-btn");
let loop = document.querySelector(".loop");

if (toggleViewBtn) {
  toggleViewBtn.addEventListener("click", function (event) {
    event.preventDefault();
  
    if (!loop.classList.contains("toggle-one") && !loop.classList.contains("toggle-two")) {
      loop.classList.add("toggle-one");
    } else if (loop.classList.contains("toggle-one")) {
      loop.classList.remove("toggle-one");
      loop.classList.add("toggle-two");
    } else if (loop.classList.contains("toggle-two")) {
      loop.classList.remove("toggle-two");
    }
  });
}
